import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  PLATFORM_ID,
} from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { isPlatformBrowser } from '@angular/common';
import { ApiService } from '../../../../../src/app/shared/services/apiService.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { RegexService } from '../../../../../src/app/shared/form-validation/regex.service';
import { Subscription } from 'rxjs';
import { RootService } from '../../../shared/services/root.service';
import { BehaviourSubjectService } from '../../../shared/services/behaviour-subject.service';
import { secureStorage } from '../../../shared/services/encryption/secureservice';

@Component({
  selector: 'app-redeem-rewards',
  templateUrl: './redeem-rewards.component.html',
  styleUrls: ['./redeem-rewards.component.scss'],
})
export class RedeemRewardsComponent implements OnInit {
  userBalance: any;
  sub: Subscription = new Subscription();
  loyalityStatementData: any=[];
  userBalRef: any;
  height: number = 0;
  width: number = 0;
  isMobile: boolean = false;
  environment1 = environment.s3bucket.url;
  showLoader: any = false;
  userData: any;
  userBal: boolean = false;
  currentRoute: any;

  constructor(
    private router: Router,
    private apiService: ApiService,
    private regexService: RegexService,
    private spinner: NgxSpinnerService,
    private secureService: RootService,
    private behaviourSubject: BehaviourSubjectService,
    private localStorage: secureStorage,

    @Inject(PLATFORM_ID) private platformId: Object
  ) {}


  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.height = window.innerHeight;
      this.width = window.innerWidth;
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }

      this.userData = this.secureService.getUserData();
      this.userBalance = JSON.parse(this.localStorage.getItem('userBalLocalSto'));
      this.getLoyalityStatementData();
      localStorage.removeItem('currentRoute');
      localStorage.removeItem('rewardTermsCondition');
    this.currentRoute = this.router.url;
    }
  }

  @Output() goBack = new EventEmitter<void>();

  onGoBack() {
    this.goBack.emit();
  }

  @Output() goBackto: EventEmitter<void> = new EventEmitter<void>();
  mobileBack() {
    this.goBack.emit();
  }

  openRewardCenter() {
    this.router.navigate(['/account/reward-center']);
  }

  getLoyalityStatementData() {
    const data = {
      mobile_number: this.userData.mobile_number,
      // "action_type":"burn",
      // "offset":0,
      // "limit":10
    };
    try {
      this.spinner.show();
      this.showLoader = true;
      this.sub.add(
        this.apiService.getloyalityStatement(data).subscribe({
          next: (res) => {
            if (res.success) {
              this.spinner.hide();
              this.showLoader = false;
              this.loyalityStatementData = res.data;
            } else {
            }
            this.spinner.hide();
          },
          error: (err) => {
            this.spinner.hide();
          },
          complete: () => {
            this.spinner.hide();
          },
        })
      );
    } catch (error) {}
  }

  navigateToRewardStatement(event: Event) {
    event.preventDefault();
    this.router.navigate(['/account/reward-statement'], {
      queryParams: { fromRedeem: true },
    });
  }


  TnCredirect(){
    this.localStorage.setItem('currentRoute', this.currentRoute);

    this.router.navigate(['/reward-terms-condition']);

  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
